<template>
  <div class="object-fit-fallback-box object-fit-fallback">
    <img      
      :src="src"
      :title="title"
      :alt="alt"
    />
  </div>
</template>

<script>
  export default {
    name: 'ObjectFit',
    props: [
      'src',
      'title',
      'alt'
    ],
    created() {
      // Detect objectFit support
      if('objectFit' in document.documentElement.style === false) {
        var container = document.getElementsByClassName('object-fit-fallback');
        for(var i = 0; i < container.length; i++) {
          var imageSource = container[i].querySelector('img').src;
          container[i].querySelector('img').style.display = 'none';
          container[i].style.backgroundSize = 'cover';
          container[i].style.backgroundImage = 'url(' + imageSource + ')';
          container[i].style.backgroundPosition = 'center center';
        }
      }
    }
  }

</script>

<style lang="scss">
  .object-fit-fallback-box {
    width: 100%;
    height: 100%;
    background-color: var(--blue);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: relative;
    }

    img:before {  
      content: " ";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: var(--blue);
    }
  }
</style>
